import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { CustomerStatus } from '@/types';
import { useCreateCustomerStatusMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface CreateCustomerStatusProps extends DialogProps {
  onClose(): void;
}

const CreateCustomerStatus: React.FC<CreateCustomerStatusProps> = ({ onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [createCustomerStatus, createCustomerStatusResponse] = useCreateCustomerStatusMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<CustomerStatus>({
    initialValues: {
      name: '',
      independent_from_depth: false,
      independent_from_interval: false,
      is_name_editable: false,
      is_simple: false,
    },
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
      independent_from_depth: yup.bool(),
      independent_from_interval: yup.bool(),
      is_name_editable: yup.bool(),
      is_simple: yup.bool(),
    }),
    async onSubmit(customerStatus, { resetForm }) {
      try {
        await createCustomerStatus(customerStatus).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Добавить статус клиента</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={createCustomerStatusResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={createCustomerStatusResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={createCustomerStatusResponse.isLoading}>
            Добавить
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateCustomerStatus;
